import { FC } from 'react'
import { BitazzaText } from '../../../../components'
import Style from './StatisticBox.module.scss'

interface Props {
    title1: string
    title2: string
    value: number | string
}

export const StatisticBox: FC<Props> = ({ title1, title2, value }) => {
    return (
        <div className={Style.container}>
            <BitazzaText
                content={title1}
                format="t14"
                color="rgba(255, 255, 255,0.5)"
                letterSpacing={2}
                display="block"
                lineHeight={10}
            />
            <BitazzaText
                content={title2}
                format="t14"
                color="rgba(255, 255, 255,0.5)"
                letterSpacing={2}
                display="block"
                lineHeight={20}
            />
            <BitazzaText
                content={value}
                format="t32"
                color="#FFF"
                letterSpacing={2}
                lineHeight={42}
                display="block"
                semiBold
            />
        </div>
    )
}
